import axios from "axios";
import { BASE_URL } from "../Constants";

export default axios.create({
  baseURL: BASE_URL,
  responseType: "json",
});
